module.exports = __webpack_public_path__ + "static/media/BannerWithoutImage@2x.bfa93bc2ae6221eaff8d4d1d8da374a8.jpg";